import { Badge } from "../ui/badge.tsx";
import { Button } from "../ui/button.tsx";
import { Card, CardContent } from "../ui/card.tsx";

import { useNavigate } from "react-router-dom";
import { TimestampFormatter } from "./FormCard.jsx";
//@ts-ignore
import mainLogo from "../../assets/images/main-logo.svg";
import { ExternalLink, Clock, Link2 } from "lucide-react";
import { useFormEditorContext } from "../../Contexts/FormEditorContext.jsx";

export function MobileFormCard({ item }) {
    const navigate = useNavigate();

    const { selectedWorkSpace } = useFormEditorContext();

    const handleResponsesClick = (id: string, status: string) => {
        sessionStorage.setItem("selectedWorkSpace", selectedWorkSpace);
        sessionStorage.setItem("formStatus", status);
        navigate(
            `/workspaces/${selectedWorkSpace}/forms/${id}/results/analytics`,
        );
    };
    return (
        <Card key={item} className="border border-gray-200 rounded-lg">
            <CardContent className="p-0">
                {/* Header */}
                <div className=" bg-[#F5F8FF] h-[58px] p-3 flex items-center justify-between">
                    <div className="flex items-center gap-3 ">
                        <div className="relative object-contain">
                            <img
                                src={`${
                                    item?.revision?.form?.settings?.meta?.image
                                        ?.link
                                        ? item?.revision?.form?.settings?.meta
                                              ?.image?.link
                                        : `https://buildform-file-uploads-v2.s3.ap-southeast-1.amazonaws.com/f5c2a6b9f27540e291644e59cff69b5f.jpeg`
                                }  `}
                                alt="form"
                                className="w-[34px] h-[34px] rounded-[4px]"
                            />
                            <div className="absolute flex left-[25%]  top-[25%] w-[15.33px] h-[15.33px] ">
                                <img src={mainLogo} alt="logo" />
                            </div>
                        </div>
                        <div className="flex items-center gap-1">
                            {item?.status === "published" ? (
                                <Badge
                                    className=" border-[#2563EB] text-[10px] font-medium text-[#2563EB]"
                                    variant={"outline"}
                                >
                                    Published
                                </Badge>
                            ) : item?.status === "draft" ? (
                                <Badge
                                    className=" border-[#8590A2] text-[10px] font-medium text-[#8590A2]"
                                    variant={"outline"}
                                >
                                    Draft
                                </Badge>
                            ) : (
                                <>
                                    <Badge
                                        className=" border-[#2563EB] text-[10px] font-medium text-[#2563EB]"
                                        variant={"outline"}
                                    >
                                        Published
                                    </Badge>
                                    <Badge
                                        className=" border-[#FACE33] text-[10px] font-medium text-[#FACE33]"
                                        variant={"outline"}
                                    >
                                        Draft
                                    </Badge>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="flex items-center gap-3 ">
                        <Button
                            variant="ghost"
                            className="p-0 bg-transparent hover:bg-transparent"
                        >
                            <Link2 className="text-gray-500 size-4" />
                        </Button>
                    </div>
                </div>

                {/* Body */}
                <div className="flex flex-col p-3">
                    <h3 className="text-[14px] text-start font-medium line-clamp-2 truncate text-primary">
                        {item?.revision?.form?.title}
                    </h3>
                    <div
                        className="flex items-center gap-1 mt-1 "
                        onClick={() => {
                            handleResponsesClick(
                                item?.revision?.form?._id,
                                item?.status,
                            );
                        }}
                    >
                        <p className="text-[10px] text-start text-[#44546F] ">
                            {item?.responses_count} responses
                        </p>
                        <ExternalLink className="text-[#44546F] size-[14px]" />
                    </div>
                    <div className=" mt-[25px] gap-1 flex items-center">
                        <Clock className="text-[#44546F] size-[14px]" />
                        <p className="text-[10px] text-[#44546F] ">
                            <TimestampFormatter
                                timestamp={item?.revision?.created_at}
                            />
                        </p>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
